import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FieldLabel from '../FieldLabel';
import cn from 'classnames';
import FieldError from '../FieldError';
import { TextBox as TextBoxDevEx } from 'devextreme-react';
import { errors } from '../../constants';
import styles from './TextBox.module.scss';

const TextBoxWithoutTrim = ({ testId, ...props }) => {
  const [isFocus, setFocus] = useState(false);
  const isLabel = props.label || !props.isValid;
  const showRequired = props.isRequired && (!props.value || props.value.trim().length === 0);

  const handleFocusIn = e => {
    props.onFocusIn && props.onFocusIn();
    setFocus(true);
  };

  const handleFocusOut = e => {
    props.onFocusOut && props.onFocusOut();
    setFocus(false);
  };

  const handleKeyPress = e => {
    // Get the pressed key code
    const keyCode = e.event.keyCode || e.event.which;

    // Check if the key is a numeric character or allowed special characters (+ and -)
    if (
      (keyCode >= 48 && keyCode <= 57) || // Numeric characters (0-9)
      keyCode === 43 || // Plus +
      keyCode === 45 || // Minus -
      keyCode === 40 || // Open Parentheses (
      keyCode === 41 || // Close Parentheses )
      keyCode === 32 // Space
    ) {
      return; // Allow the keypress
    } else {
      e.event.preventDefault(); // Prevent the keypress
    }
  };

  const handleValueChange = e => {
    const event = e;
    props.onValueChanged && props.onValueChanged(event);
  };

  return <div>
    {isLabel && <div>
      {props.label && <FieldLabel text={props.label} size={props.labelSize} />}
      {!props.hideErrorIcon && (!props.isValid || showRequired) && <FieldError isFocus={isFocus} error={props.errorText || errors.INCOMPLETE_DATA_FIELD} />}
    </div>}
    <TextBoxDevEx
      {...props}
      inputAttr={{
        autocomplete: 'no',
        ...(testId && { 'data-testid': testId })
      }}
      className={cn({
        [styles.incomplete]: props.isIncomplete
      })}
      labelMode='hidden'
      isValid={showRequired ? !!(props.value && props.value.trim().length > 0) : props.isValid}
      onFocusIn={handleFocusIn}
      onFocusOut={handleFocusOut}
      onValueChanged={handleValueChange}
      onKeyPress={handleKeyPress}
      showClearButton={props.showClearButton && isFocus}>
      {props.children && props.children}
    </TextBoxDevEx>
  </div>;
};

TextBoxWithoutTrim.defaultProps = {
  isValid: true
};

TextBoxWithoutTrim.propTypes = {
  label: PropTypes.string,
  labelSize: PropTypes.number,
  isValid: PropTypes.bool,
  isRequired: PropTypes.bool,
  readOnly: PropTypes.bool,
  showClearButton: PropTypes.bool,
  isIncomplete: PropTypes.bool,
  value: PropTypes.string,
  errorText: PropTypes.string,
  moreInfo: PropTypes.string,
  labelIcon: PropTypes.array,
  onValueChanged: PropTypes.func,
  onOptionChanged: PropTypes.func,
  onFocusIn: PropTypes.func,
  onFocusOut: PropTypes.func,
  hideErrorIcon: PropTypes.bool,
  children: PropTypes.node,
  testId: PropTypes.string
};

export default TextBoxWithoutTrim;
